/**
 * @description
 * Este arquivo define as rotas (paths) do frontend da aplicação (vulgo os diferentes caminhos da URL).
 *
 * As rotas descritas no arquivo `src/utils/axios.ts` são referentes aos endpoints do backend,
 * que serão utilizados para a integração do front-end ao back-end, via repositories.
 */

const ROOTS = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  ADMIN_USER: "/admin-user",
  ADMIN_USERS: "/admin-users",
  APP_USERS: "/app-users",
  PRODUCTS: "/products",
  OFFERS: "/offers",
  HOME: "/home",
  CONVERSION_RATE: "/conversionrate",
  RULES: "/rules",
  VARIABLES: "/variables",
  REDEEMS: "/redeems",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  SELLERS: "/sellers",
  RANKING: "/ranking",
};

export const paths = {
  root: "/",
  auth: {
    root: ROOTS.AUTH,
    login: `${ROOTS.AUTH}/login`,
    register: `${ROOTS.AUTH}/register`,
    refresh: `${ROOTS.AUTH}/refresh`,
  },
  // DOCUMENTOS

  error: {
    notFound: "/404",
    forbidden: "/403",
    serverError: "/500",
  },

  // PAGES
  dashboard: {
    root: ROOTS.DASHBOARD,

    // USUÁRIOS ADMINISTRADORES
    adminUsers: {
      root: `${ROOTS.DASHBOARD}${ROOTS.ADMIN_USER}`,
      create: `${ROOTS.DASHBOARD}${ROOTS.ADMIN_USER}/create`,
      update: `${ROOTS.DASHBOARD}${ROOTS.ADMIN_USER}/update/:id`,
      inactivate: `${ROOTS.DASHBOARD}${ROOTS.ADMIN_USER}/inactivate/:id`,
    },

    conversionRate: {
      root: `${ROOTS.DASHBOARD}${ROOTS.CONVERSION_RATE}`,
      create: `${ROOTS.DASHBOARD}${ROOTS.CONVERSION_RATE}/create`,
      edit: `${ROOTS.DASHBOARD}${ROOTS.CONVERSION_RATE}/:id`,
    },
    rules: {
      root: `${ROOTS.DASHBOARD}${ROOTS.RULES}`,
      edit: `${ROOTS.DASHBOARD}${ROOTS.RULES}/:id`,
      create: `${ROOTS.DASHBOARD}${ROOTS.RULES}/create`,
    },
    variables: `${ROOTS.DASHBOARD}${ROOTS.VARIABLES}`,

    // USUÁRIOS DO APP
    appUsers: {
      root: `${ROOTS.DASHBOARD}${ROOTS.APP_USERS}`,
      edit: `${ROOTS.DASHBOARD}${ROOTS.APP_USERS}/:id`,
    },

    // PRODUTOS (BENEFÍCIOS)
    products: {
      root: `${ROOTS.DASHBOARD}${ROOTS.PRODUCTS}`,
      create: `${ROOTS.DASHBOARD}${ROOTS.PRODUCTS}/create`,
      edit: `${ROOTS.DASHBOARD}${ROOTS.PRODUCTS}/:id`,
    },

    redeems: {
      root: `${ROOTS.DASHBOARD}${ROOTS.REDEEMS}`,
    },

    terms: {
      root: `${ROOTS.DASHBOARD}${ROOTS.TERMS}`,
      create: `${ROOTS.DASHBOARD}${ROOTS.TERMS}/create`,
      edit: `${ROOTS.DASHBOARD}${ROOTS.TERMS}/:id`,
      duplicate: `${ROOTS.DASHBOARD}${ROOTS.TERMS}/duplicate`,
    },
    privacy: {
      root: `${ROOTS.DASHBOARD}${ROOTS.PRIVACY}`,
      create: `${ROOTS.DASHBOARD}${ROOTS.PRIVACY}/create`,
      edit: `${ROOTS.DASHBOARD}${ROOTS.PRIVACY}/:id`,
      duplicate: `${ROOTS.DASHBOARD}${ROOTS.PRIVACY}/duplicate`,
    },

    // OFFERS
    offers: {
      root: `${ROOTS.DASHBOARD}${ROOTS.OFFERS}`,
    },

    home: {
      root: `${ROOTS.DASHBOARD}${ROOTS.HOME}`,
      create: `${ROOTS.DASHBOARD}${ROOTS.HOME}/create`,
      edit: `${ROOTS.DASHBOARD}${ROOTS.HOME}/:id`,
    },

    // SELLERS
    sellers: {
      root: `${ROOTS.DASHBOARD}${ROOTS.SELLERS}`,
    },

    // RANKING
    ranking: {
      root: `${ROOTS.DASHBOARD}${ROOTS.RANKING}`,
    },
  },
};
